import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import BindingForm from "../../../../components/PMWork/BindContract/BindingForm";
import CustContractItemsService from "../../../../services/custcontractitem.service";

export default function BindingTab() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  return (
    <BindingForm
      onSubmitCallback={(data) =>
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest:
            CustContractItemsService.createCustContractItems(data),
          navigated: (navi) => {
            if (navi) {
              navigate("/PM_work/bind", { state: { name: "binding" } });
              navigate(0);
            }
          }
        })
      }
    />
  );
}
